import React from 'react';
import { FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa'; // Import the icons
import './ContactUsFooter.css';

const ContactUsFooter = () => {
    return (
        <footer className="footer1">
            <div className="footer-container1">
                <div className="footer-logo1">
                    <div className="footer-main-logo1">
                        <img src="/pictures/HGC-logo4.png" width="200" alt="Dental Clinic Logo" />
                    </div>
                    {/* Move the footer contact below the logo */}
                    <div className="footer-contact1">
                        <p>
                            <FaMapMarkerAlt /> 17 P. Poblete Street Barangay Gombalza, Naic Cavite
                        </p>
                    </div>
                    <div className="footer-phone1">
                        <p>
                            <FaPhoneAlt /> +639158684377
                        </p>
                    </div>
                </div>
                <div className="footer-columns1">
                    <div>
                        <h4>Services</h4>
                        <a href="/AllServices" className= "footer-link"> Price List
                        </a>
                        <p>Operating Hours</p>
                    </div>
                    <div>
                        <h4>About Us</h4>
                        <a href="#aboutus-container" className= "footer-link"> About HGC Clinic </a>
                    </div>
                    <div>
                        <h4>Support</h4>
                        <p>FAQ</p>
                        <a href="#contact-us-content" className= "footer-link"> Contact Us </a>
                        <p>
                            <a href="/feedback" className= "footer-link">
                                Feedback
                            </a>
                        </p>
                    </div>
                </div>
            </div>
            <div className="divider">
                <div className="footer-below1">
                    <p>Privacy Policy</p>
                    <p>Terms and Conditions</p>
                </div>
            </div>
        </footer>
    );
};

export default ContactUsFooter;